import { c as _c } from "react/compiler-runtime";
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { clientApi } from '../../configuration';
import { getCRUDHooks, usePagination } from '../../utils';
const {
  useGet: useTeamAnalytics
} = getCRUDHooks({
  entityName: 'teamAnalytics',
  async get({
    reports,
    id,
    asCsv,
    withHeaders = false
  }) {
    const response = await clientApi.getOCClient().helpers.employer.teams.id(id).analytics.find({
      reports,
      asCsv
    });
    return withHeaders ? {
      body: response
    } : response;
  }
});
const usePaginatedTeamAnalytics = t0 => {
  const $ = _c(29);
  const {
    id: teamId,
    code,
    filters,
    orderBy,
    asCsv: t1,
    itemsByPage: t2,
    defaultPage: t3,
    groupBy
  } = t0;
  const asCsv = t1 === undefined ? false : t1;
  const itemsByPage = t2 === undefined ? 10 : t2;
  const defaultPage = t3 === undefined ? 1 : t3;
  let t4;
  if ($[0] !== defaultPage || $[1] !== itemsByPage) {
    t4 = {
      itemsByPage,
      defaultPage
    };
    $[0] = defaultPage;
    $[1] = itemsByPage;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const [pagination, currentRange, getTotalPages] = usePagination(t4);
  const paginationRange = `${currentRange.start}-${currentRange.end}`;
  let t5;
  if ($[3] !== code || $[4] !== filters || $[5] !== groupBy || $[6] !== orderBy || $[7] !== paginationRange) {
    t5 = [{
      code,
      filters,
      orderBy,
      pagination: paginationRange,
      groupBy
    }];
    $[3] = code;
    $[4] = filters;
    $[5] = groupBy;
    $[6] = orderBy;
    $[7] = paginationRange;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== asCsv || $[10] !== t5 || $[11] !== teamId) {
    t6 = ["paginatedTeamAnalytics", teamId, t5, asCsv];
    $[9] = asCsv;
    $[10] = t5;
    $[11] = teamId;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== asCsv || $[14] !== code || $[15] !== filters || $[16] !== getTotalPages || $[17] !== groupBy || $[18] !== orderBy || $[19] !== pagination || $[20] !== paginationRange || $[21] !== teamId) {
    t7 = async () => {
      const {
        employer
      } = clientApi.getOCClient().helpers;
      const {
        body
      } = await employer.teams.id(teamId).analytics.find({
        reports: [{
          code,
          filters,
          orderBy,
          pagination: paginationRange,
          groupBy
        }],
        asCsv
      });
      const [t8] = body;
      const {
        data: items,
        pagination: responseHeaderPaginationLike
      } = t8;
      let totalItems = items.length;
      if (responseHeaderPaginationLike) {
        const headerData = responseHeaderPaginationLike.split("/");
        totalItems = +headerData[1];
      }
      return {
        items,
        totalItems,
        totalPages: getTotalPages(totalItems),
        pagination
      };
    };
    $[13] = asCsv;
    $[14] = code;
    $[15] = filters;
    $[16] = getTotalPages;
    $[17] = groupBy;
    $[18] = orderBy;
    $[19] = pagination;
    $[20] = paginationRange;
    $[21] = teamId;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t6 || $[24] !== t7) {
    t8 = {
      queryKey: t6,
      queryFn: t7,
      placeholderData: keepPreviousData
    };
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  const paginatedQueryResponse = useQuery(t8);
  let t9;
  if ($[26] !== paginatedQueryResponse || $[27] !== pagination) {
    t9 = {
      ...paginatedQueryResponse,
      pagination
    };
    $[26] = paginatedQueryResponse;
    $[27] = pagination;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
};
export { useTeamAnalytics, usePaginatedTeamAnalytics };